import { HttpStatusCode } from "axios";
import React, { useState } from "react";
import { ApiOldAppImportControllerUrl, ApiSuperAdminFixUrl } from "../../../api/axios.url";
import { useAlertContext } from "../../../context/AlertProvider";
import { useApi } from "../../../context/ApiProvider";
import CustomChakraButton from "../../CustomChakraButton/CustomChakraButton";
import FileInput from "../../FileInput/FileInput";
import FormInput from '../../Forms/FormInput/FormInput';


const ImportData = () => {
  const { apiOldAppImportController, apiSuperAdminFixController } = useApi();
  const { setShow, setAlertProperties } = useAlertContext();
  const [importedTenantId, setImportedTenantId] = useState<string>();
  const [sourceTenantId, setSourceTenantId] = useState<string>();
  const [targetTenantId, setTargetTenantId] = useState<string>();
  const [file, setFile] = useState<{
    saldoDifference : FileList | undefined,
    saldo: FileList | undefined,
    data: FileList | undefined
  }>({
    saldoDifference: undefined,
    saldo: undefined,
    data: undefined,
  });

  const [ textResponse, setTextResponse ] = useState<{
    saldoDifference: string | undefined,
    saldo: string | undefined,
    data: string | undefined
  }>({
    saldoDifference: undefined,
    saldo: undefined,
    data: undefined,
  })

  const handleImportedTenantId = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      setImportedTenantId(value);
  };
  const handleSourceTenantId = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      setSourceTenantId(value);
  };
  const handleTargetTenantId = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      setTargetTenantId(value);
  };

  const handleFix = async () =>{
   try {
        const response = await apiSuperAdminFixController('fix-things').get('');
        if(response.status !== HttpStatusCode.Ok){
          setAlertProperties({
            timeout: 9000,
            title: "Błąd",
            description: `Błąd fixu`,
            status: "error"
          });
          setShow(true);
        } else{
          setAlertProperties({
            timeout: 9000,
            title: "Udany fix",
            description: `Fix się udał`,
            status: "success"
          });
          setShow(true);
        }
      } catch (error: any) {

      }

  }
  const handleCopy = async () =>{
   try {
        const response = await apiSuperAdminFixController('copy-parents-and-pupils').post('', {
           sourceTenantId: sourceTenantId,
           targetTenantId: targetTenantId
         });
        if(response.status !== HttpStatusCode.Ok){
          setAlertProperties({
            timeout: 9000,
            title: "Błąd",
            description: `Błąd kopii`,
            status: "error"
          });
          setShow(true);
        } else{
          setAlertProperties({
            timeout: 9000,
            title: "Udany fix",
            description: `Kopia się udała`,
            status: "success"
          });
          setShow(true);
        }
      } catch (error: any) {

      }

  }

  const handleImport = async (importType: ApiOldAppImportControllerUrl) => {
    let formData = new FormData();

    if(importType === 'import-company'){
      if (!file.data || file.data.length === 0) {
        return;
      }
      if (importedTenantId){
        formData.append("importedTenantId", importedTenantId);
      }
      if (file.data) {
        formData.append("file", file.data[0]);
      }
    }

    if (importType === 'import-saldo-info'){
      if (!file.saldo || file.saldo.length === 0) {
        return;
      }
      if (importedTenantId){
          formData.append("importedTenantId", importedTenantId);
      }
      if (file.saldo) {
        formData.append("file", file.saldo[0]);
      }
    }
    if (importType === 'import-differential-saldo-info'){
      if (!file.saldoDifference || file.saldoDifference.length === 0) {
        return;
      }
      if (importedTenantId){
          formData.append("importedTenantId", importedTenantId);
      }
      if (file.saldoDifference) {
        formData.append("file", file.saldoDifference[0]);
      }
    }

    try {
      setAlertProperties({
        timeout: 3000,
        title: "Rozpoczeto importu",
        description: 'Rozpoczeto import',
        status: "success"
      });
      setShow(true);
      setTextResponse((prev) => ({...prev, saldo: 'rozpoczeto import' }))
      const response = await apiOldAppImportController(importType).post('',formData);


      if(importType === 'import-saldo-info'){
        setTextResponse((prev) => ({...prev, saldo: response.data }))
      }
      if(importType === 'import-company'){
        setTextResponse((prev) => ({...prev, data: response.data }))
      }
      if(importType === 'import-differential-saldo-info'){
        setTextResponse((prev) => ({...prev, data: response.data }))
      }

      if(response.status === HttpStatusCode.Ok){
         setAlertProperties({
          timeout: 9000,
          title: "Sukces importu",
          description: `Udany import plikow: ` + response.data,
          status: "success"
        });
        setShow(true);
      }
    } catch (error: any) {
        console.warn(error?.response.status);
        setAlertProperties({
          timeout: 9000,
          title: "Błąd",
          description: `${error?.response?.data?.errorMessage || 'Nieznany błąd importu danych'}`,
          status: "error"
        });
        setShow(true);
    }
  }

  return (
    <section className='w-full h-full p-spacing-4xl items-start justify-center'>
      <div className="Settings__header flex justify-between w-full">
        <p className="m-0 p-0 font-semibold text-lg text-grayLight-900">Napraw</p>
        <CustomChakraButton
          hierarchy="secondaryColor"
          size="sm"
          iconPosition="onlyText"
          buttonProps={{
            onClick: () => {handleFix()},
            className: "grow",
          }}
        >
          Napraw
        </CustomChakraButton>
      </div>
      <div className="Settings__header flex justify-between w-full">
        <p className="m-0 p-0 font-semibold text-lg text-grayLight-900">Import danych</p>
      </div>
      <div className="Settings__formContainer w-full">
        <div className="w-full flex flex-col gap-spacing-4xl overflow-y-auto pb-spacing-11xl">
          <div className="grow flex flex-col gap-spacing-lg">
            <div className="text-sm font-medium text-grayLight-500 border-b border-grayLight-200">
              Importuj dane
            </div>
            <div className='flex gap-spacing-5xl'>
              <div className="w-96">
               <FormInput
                  label="Nr oddziału ze starego systemu"
                  placeholder="Jak pole będzie puste to się wszystkie oddziały zaimportują"
                  inputParams={{
                    value: importedTenantId,
                    name: 'importedTenantId',
                    required: false,
                    onChange: handleImportedTenantId
                  }}
                />
                <FileInput
                  onFileUpload={(file) => {
                    setFile((prev) => ({ ...prev, data: file }));
                  }}
                  description="PDF, PNG, JPG lub plik Excela (max. 2000 mb)"
                />
                <p>{textResponse.data}</p>
              </div>
              <div>
                <CustomChakraButton
                  hierarchy="secondaryColor"
                  size="sm"
                  iconPosition="onlyText"
                  buttonProps={{
                    onClick: () => {handleImport('import-company')},
                    className: "grow",
                    disabled: !file.data,
                  }}
                >
                  Importuj dane
                </CustomChakraButton>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col gap-spacing-4xl overflow-y-auto pb-spacing-11xl">
          <div className="grow flex flex-col gap-spacing-lg">
            <div className="text-sm font-medium text-grayLight-500 border-b border-grayLight-200">
              Importuj salda
            </div>
            <div className='flex gap-spacing-5xl'>
              <div className="w-96">
                <FormInput
                  label="Nr oddziału ze starego systemu"
                  placeholder="Jak pole będzie puste to się wszystkie oddziały zaimportują"
                  inputParams={{
                    value: importedTenantId,
                    name: 'importedTenantId',
                    required: false,
                    onChange: handleImportedTenantId
                  }}
                />
                <FileInput
                  onFileUpload={(file) => {
                    setFile((prev) => ({ ...prev, saldo: file }));
                  }}
                  description="PDF, PNG, JPG lub plik Excela (max. 2000 mb)"
                />
                <p>{textResponse.saldo}</p>
              </div>
              <div>
                <CustomChakraButton
                  hierarchy="secondaryColor"
                  size="sm"
                  iconPosition="onlyText"
                  buttonProps={{
                    onClick: () => {handleImport('import-saldo-info')},
                    className: "grow",
                    disabled: !file.saldo,
                  }}
                >
                  Importuj salda
                </CustomChakraButton>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col gap-spacing-4xl overflow-y-auto pb-spacing-11xl">
          <div className="grow flex flex-col gap-spacing-lg">
            <div className="text-sm font-medium text-grayLight-500 border-b border-grayLight-200">
              Importuj salda różnicowe
            </div>
            <div className='flex gap-spacing-5xl'>
              <div className="w-96">
                <FormInput
                  label="Nr oddziału ze starego systemu"
                  placeholder="Jak pole będzie puste to się wszystkie oddziały zaimportują"
                  inputParams={{
                    value: importedTenantId,
                    name: 'importedTenantId',
                    required: false,
                    onChange: handleImportedTenantId
                  }}
                />
                <FileInput
                  onFileUpload={(file) => {
                    setFile((prev) => ({ ...prev, saldoDifference: file }));
                  }}
                  description="PDF, PNG, JPG lub plik Excela (max. 2000 mb)"
                />
                <p>{textResponse.saldoDifference}</p>
              </div>
              <div>
                <CustomChakraButton
                  hierarchy="secondaryColor"
                  size="sm"
                  iconPosition="onlyText"
                  buttonProps={{
                    onClick: () => {handleImport('import-differential-saldo-info')},
                    className: "grow",
                    disabled: !file.saldoDifference,
                  }}
                >
                  Importuj salda różnicowe
                </CustomChakraButton>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <p className="m-0 p-0 font-semibold text-lg text-grayLight-900">Kopiowanie z oddziału do odziału</p>
        <p>Kopiowanie z oddziału do oddziału, przypisuje rodziców (tylko rodziców, bez nauczycieli/pracowników)
        do docelowego odziału (rodzice dostają mail'a o przypisaniu do nowego oodziału). Dzieci są kopiowane i przypisywane do tych samych rodziców.
        Żeby dzieci trafiły do tych samych klas, muszą one już istnieć w oddziale docelowym</p>
        <div className="w-96">
          <FormInput
            label="Nr oddziału źródłowego"
            placeholder="Numer id"
            inputParams={{
              value: sourceTenantId,
              name: 'sourceTenantId',
              required: false,
              onChange: handleSourceTenantId
            }}
          />
          <FormInput
            label="Nr oddziału docelowego"
            placeholder="Docelowy id"
            inputParams={{
              value: targetTenantId,
              name: 'targetTenantId',
              required: false,
              onChange: handleTargetTenantId
            }}
          />
        </div>
          <CustomChakraButton
            hierarchy="secondaryColor"
            size="sm"
            iconPosition="onlyText"
            buttonProps={{
              onClick: () => {handleCopy()},
              className: "grow",
            }}
          >
            Skopiuj z oddziału do oddziału
          </CustomChakraButton>
      </div>
    </section>
  );
};

export default ImportData;
